import { render, staticRenderFns } from "./business_category.vue?vue&type=template&id=7ed62c00&scoped=true&"
import script from "./business_category.vue?vue&type=script&lang=js&"
export * from "./business_category.vue?vue&type=script&lang=js&"
import style0 from "./business_category.vue?vue&type=style&index=0&id=7ed62c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed62c00",
  null
  
)

export default component.exports